// store
const store = {
    getClientData(){
        let clientData = window.sessionStorage.getItem('x-client-data');
        if (typeof (clientData) == 'string' && clientData.length > 0) {
            return (new TextDecoder()).decode(new Uint8Array(clientData.split(',')));
        } else {
            return null;
        }
    },
    getUser(){
        let user = window.sessionStorage.getItem('x-user');
        if (typeof (user) == 'string' && user.length > 0) {
            return JSON.parse((new TextDecoder()).decode(new Uint8Array(user.split(','))));
        } else {
            return null;
        }
    },
    getToken(){
        let token = window.sessionStorage.getItem('x-token');
        if (typeof (token) == 'string' && token.length > 0) {
            return (new TextDecoder()).decode(new Uint8Array(token.split(',')));
        } else {
            return null;
        }
    },
    setClientData(clientData){
        window.sessionStorage.removeItem('x-client-data');
        if (typeof (clientData) == 'string' && clientData.length > 0) {
            window.sessionStorage.setItem('x-client-data', (new TextEncoder()).encode(clientData));
        }
    },
    setUser(user){
        window.sessionStorage.removeItem('x-user');
        if (typeof (user) == 'object') {
            window.sessionStorage.setItem('x-user', (new TextEncoder()).encode(JSON.stringify(user)));
        }
    },
    setToken(token){
        window.sessionStorage.removeItem('x-token');
        if (typeof (token) == 'string' && token.length > 0) {
            window.sessionStorage.setItem('x-token', (new TextEncoder()).encode(token));
        }
    },
    removeAll(){
        window.sessionStorage.clear();
    }
}

export { store };